import APIUtil from 'util/APIUtil';

/** Determines whether Table Mapping is allowed in a given document type */
export default function allowTableMappingInDocument(docId: string | null | undefined): boolean {
  if (!docId) {
    return false;
  }
  if (APIUtil.isDocument(docId) || APIUtil.isNotebookEntryOrTemplate(docId) || APIUtil.isSubtemplate(docId)) {
    return true;
  }
  return false;
}
